import "./Footer.css";
import "../theme/GlobalStyles.css";
import appLogo from "../assets/images/Logo_Clewer_White.png";
import FAQsModal from "./FAQsModal";
import { useState } from "react";

const Footer = () => {
  const [showFAQsModal, setShowFAQsModal] = useState(false);

  return (
    <div id="footer">
      <img src={appLogo} alt="App logo" width="172px" height="80px" />
      <div>
        <p>
          <a
            className="pointerCursor"
            style={{ color: "var(--p-20)", textDecoration: "none" }}
            onClick={() => setShowFAQsModal(true)}
          >
            Frequently Asked Questions
          </a>
        </p>
        <p>
          To report any issues contact{" "}
          <a
            style={{ color: "var(--p-20)", textDecoration: "none" }}
            href="mailto:info@clewer.org.uk"
          >info@clewer.org.uk
          </a>
        </p>
        {/* <p>
          Developed by{" "}
          <a style={{ color: "var(--p-20)", textDecoration: "none" }} target={"_blank"} href="https://aimermedia.com/">
            Pocket App
          </a>
        </p> */}
      </div>
      <FAQsModal isOpen={showFAQsModal} handleModalDismiss={() => setShowFAQsModal(false)} />
    </div>
  );
};

export default Footer;
